import { GroupSecurity } from '@quromedical/fhir-common';
import { Row } from 'components/base';
import * as Card from 'components/card';
import { LinkButton } from 'components/input';
import { WithGroup } from 'core/auth';
import type React from 'react';

interface PatientServiceRequestActionsCardProps {
  patientId: string;
}

// NOTE: This screen is not being used anywhere
export const PatientServiceRequestActionsCard: React.FC<
  PatientServiceRequestActionsCardProps
> = ({ patientId }) => (
  <Card.BaseWrapper>
    <Row>
      <WithGroup groups={[GroupSecurity.ServiceRequestCreate]}>
        <LinkButton
          text="Create Ampath Request"
          href={`/patient/${patientId}/service-request`}
        />
      </WithGroup>
      <WithGroup groups={[GroupSecurity.ServiceRequestRead]}>
        <LinkButton
          text="View All"
          href={`/patient/${patientId}/service-request`}
        />
      </WithGroup>
    </Row>
  </Card.BaseWrapper>
);
